import { useEffect, useState } from 'react';

import { ListItemButton, Typography } from '@mui/material';

import { getPatients } from 'apis/admin';
import usePatient from 'store/patient/usePatient';
import MuiAutocomplete from 'components/MuiAutocomplete';

import { getNursingRecords } from 'apis/main';
import { ReactComponent as Cookie } from 'assets/alarm-icon.svg';
import { ReactComponent as Empty } from 'assets/alarm-icon-empty.svg';

interface IOption {
  patient_id: string;
  patient_virtual_id?: string;
  name: string;
  age: string;
}

interface Props {
  user_id: number;
}

const PatientsList = ({ user_id }: Props) => {
  const { onSelectedPatient } = usePatient();

  const optionLabel = ({ patient_id, patient_virtual_id, name }: IOption) =>
    `${patient_virtual_id || patient_id} ${name}`;

  const Option = ({ patient_id, patient_virtual_id, name, age, ...props }: IOption) => {
    const [nursingRecord, setNursingRecord] = useState([]);
    const displayPatientId = patient_virtual_id || patient_id;

    useEffect(() => {
      // Ecardex
      getNursingRecords({
        page: 1,
        user_id,
        patient_id: Number(`${patient_id}`),
      }).then(({ data }) => {
        // console.log('데이터', data);
        setNursingRecord(data.nursing_records);
      });
    });

    if (nursingRecord) {
      return (
        <ListItemButton {...props} sx={{ gap: 0.2 }}>
          <Empty />
          <Typography
            variant="subtitle2"
            fontSize="14px"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {displayPatientId}
          </Typography>
          <Typography variant="caption" fontSize="14px" color={'#000000B2'}>
            {name}
          </Typography>
          <Typography
            variant="caption"
            fontSize="14px"
            color={'#000000B2'}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {age}
          </Typography>
        </ListItemButton>
      );
    } else {
      return (
        <ListItemButton {...props} sx={{ gap: 0.2 }}>
          <Cookie />
          <Typography
            variant="subtitle2"
            fontSize="14px"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {displayPatientId}
          </Typography>
          <Typography variant="caption" fontSize="14px" color={'#000000B2'}>
            {name}
          </Typography>
          <Typography
            variant="caption"
            fontSize="14px"
            color={'#000000B2'}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {age}
          </Typography>
        </ListItemButton>
      );
    }
  };

  return (
    <MuiAutocomplete
      syncWithPatient
      autoSelectFirst
      variant="standard"
      valueKey="patient_id"
      listKey="admin_patients"
      placeholder="환자 검색"
      noOptionsText="No patient found. Please enter another patient name"
      getOptionLabel={optionLabel}
      renderOption={(props, option) => {
        if (!user_id) {
          return null;
        } else return <Option {...props} {...option} />;
      }}
      onChange={onSelectedPatient}
      getApi={params => getPatients({ ...params, user_id })}
    />
  );
};

export default PatientsList;
